<script lang="ts">
  import ValidationError from "@shared/svelte/Components/ValidationError.svelte";
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import type { Errors } from "@shared/types/Errors";
  import type { UserSignUp } from "@shared/types/User";
  import { form, bindClass } from "@shared/lib/svelte-forms";
  import SignupUserStore from "@onboarding2/svelte/Stores/SignupUserStore";
  import { onDestroy } from "svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { email } from "@shared/svelte/Validators/Email";
  import { completeValidation } from "@shared/svelte/Validators/utils";

  export let onValidEmailEntered: (email: string) => void;

  const signupUserStore = SignupUserStore({});
  const user: UserSignUp = {};

  let submitting = false;
  let errors: Errors = { messages: [] };

  const userOnboardingForm = form(
    () => ({
      email: { value: user.email, validators: ["required", email] },
    }),
    {
      initCheck: false,
      validateOnChange: false,
    }
  );

  const unsubscribeErrors = signupUserStore.errors.subscribe(n => {
    if (n) {
      if (n.messages[0] == "Email has already been taken") {
        n.messages[0] =
          "This email address is already in use. <a href='/users/sign_in?ref=1' onclick=\"window.location.href='/users/sign_in?ref=1';\">Login</a> or <a href='/start/passwordReset' onclick=\"window.location.href='/start/passwordReset';\">recover your password</a>.";
      }
    }
    errors = n;
  });

  const runSubmitUserWrapper = async () => {
    await completeValidation(userOnboardingForm, $userOnboardingForm);

    if (!$userOnboardingForm.valid) {
      userOnboardingForm.markDirty();
      return;
    }

    submitting = true;

    HttpPromise({
      method: "GET",
      url: "/api/onboarding/check_email",
      data: { email: user.email },
    })
      .then(res => {
        submitting = false;
        if (res.message == "Email has already been taken") {
          signupUserStore.errors.update(() => {
            return { messages: [res.message] };
          });
        } else {
          onValidEmailEntered(user.email);
        }
      })
      .catch(res => {
        submitting = false;
        signupUserStore.errors.update(() => {
          return { messages: [res.error] };
        });
      });
  };

  onDestroy(unsubscribeErrors);

</script>

<FormErrors {errors} />
<!-- svelte-ignore component-name-lowercase -->
<form on:submit|preventDefault={runSubmitUserWrapper} data-testid="email-form">
  <div class="fizz-layout-one-col-centered">
    <div class="fizz-center-content fizz-stack-32 fizz-heading-1">Sign up for Provi</div>
    <div class="fizz-stack-32">
      <label class="fizz-label fizz-stack-4" for="email">Email</label>
      <input
        autocomplete="email"
        type="email"
        id="email"
        data-testid="email"
        name="email"
        class="fizz-input-text fizz-full-width"
        bind:value={user.email}
        use:bindClass={{ form: userOnboardingForm }}
        on:blur={userOnboardingForm.validate}
        on:focus={userOnboardingForm.validate}
      />
      <ValidationError name="Email" fieldObj={$userOnboardingForm.fields.email} />
    </div>

    <button
      class="fizz-button-secondary fizz-button fizz-full-width"
      data-testid="submit"
      disabled={submitting}>Sign up</button
    >
  </div>
</form>
